import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Solution } from '../components/Solution';
import { PlatformSection } from '../components/PlatformSection';
import { DemoSection } from '../components/DemoSection';
import { Testimonials } from '../components/Testimonials';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Solution />
      <PlatformSection />
      <DemoSection />
      <Testimonials />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Home;
